import { GraphQLClient } from 'graphql-request';

const DATO_CMS_ENDPOINT = 'https://graphql.datocms.com/';

const datoCMSClient = new GraphQLClient(DATO_CMS_ENDPOINT, {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_DATOCMS_API_TOKEN}`,
  },
});

export default datoCMSClient;
